import Icon from '@/components/ui/AppIcon';

const steps = [
  {
    id: 'step_1',
    number: '01',
    icon: 'ClipboardDocumentListIcon',
    title: 'Book Your Shipment',
    description: 'Enter shipment details and get instant quote. Choose from multiple service options.',
  },
  {
    id: 'step_2',
    number: '02',
    icon: 'ArchiveBoxIcon',
    title: 'Pack & Label',
    description: 'Prepare your package with our guidelines. Print shipping label from your dashboard.',
  },
  {
    id: 'step_3',
    number: '03',
    icon: 'public/assets/images/ChatGPT_Image_Feb_7_2026_02_48_47_AM-1770428942096.png',
    title: 'Ship & Track',
    description: 'Drop off at location or schedule pickup. Track in real-time with country-specific codes.',
  },
  {
    id: 'step_4',
    number: '04',
    icon: 'CheckBadgeIcon',
    title: 'Delivered',
    description: 'Receive delivery confirmation. Get proof of delivery with signature and photo.',
  },
];

export default function HowItWorksSection() {
  return (
    <section className="py-24 bg-gradient-to-br from-secondary/5 to-primary/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-foreground mb-4">
            How It Works
          </h2>
          <p className="text-lg text-muted-foreground">
            Simple, transparent process from booking to delivery
          </p>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={step.id} className="relative">
              {/* Connector Line (hidden on last item) */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-16 left-1/2 w-full h-0.5 bg-border -z-10"></div>
              )}

              <div className="text-center">
                {/* Icon Circle */}
                <div className="relative inline-flex items-center justify-center w-24 h-24 bg-white rounded-full border-4 border-primary/20 mb-6 group-hover:border-primary transition-colors">
                  <Icon name={step.icon as any} size={40} className="text-primary" />
                  <span className="absolute -top-2 -right-2 w-8 h-8 bg-primary text-primary-foreground rounded-full flex items-center justify-center text-sm font-bold">
                    {step.number}
                  </span>
                </div>

                {/* Content */}
                <h3 className="text-xl font-heading font-semibold text-foreground mb-2">
                  {step.title}
                </h3>
                <p className="text-sm text-muted-foreground">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}